export default __webpack_public_path__ + "static/flowers-4c057fbceb3573122ed2efd589cfa29b.png";